import { useMutation, useQueryClient } from "@tanstack/react-query";
import { UpdateCallConfigInput } from "../schemas/call-flow.schema";
import { updateCallFlow } from "../actions/update-call-flow.action";
import { useGlobalSnackbar } from "src/context/SnackbarContext";
import { callFlowQueryKeys } from "../queries/call-flow.query";

export const useCallFlowMutation = () => {
    const queryClient = useQueryClient()
    const { showSnackbar } = useGlobalSnackbar()

    const updateFlow = useMutation({
        mutationFn: ({ companyId, payload }: { companyId: number, payload: UpdateCallConfigInput }) => {
            return updateCallFlow(companyId, payload)
        },

        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: callFlowQueryKeys.all });
            showSnackbar("Call flow updated successfully", "success")
        },

        onError: () => {
            showSnackbar("Failed to update call flow", "error")
        }
    })

    return { update: updateFlow }
}